function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualStarterscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 370 244",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Manual-mode-starting-screen",
    x: 0,
    y: 0,
    width: 369.911,
    height: 243.732,
    style: {
      fill: "#f7f0e2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.216,201.448l4.177,0.213l-0.045,-3.537l-3.309,-0.49",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.183,173.582c-4.696,1.345 -14.647,4.905 -20.415,5.129c-5.935,0.23 -12.868,1.108 -17.19,-1.973c-3.775,-2.691 -5.281,-8.194 -5.025,-12.295c0.631,-10.114 7.089,-9.812 10.837,-12.935c1.278,-1.065 -7.178,-4.468 -9.41,-13.218c-2.829,-11.09 5.43,-22.074 14.723,-22.433c4.338,-0.167 7.243,0.883 9.339,2.922c2.298,2.235 2.304,3.88 5.474,5.843c1.07,0.663 5.575,-5.013 12.141,-2.181c3.239,1.397 4.732,9.26 3.346,15.441c0.883,-0.994 9.797,-4.595 14.068,-0.81c4.717,4.179 5.714,11.313 2.033,19.559c-0.952,2.133 -3.193,6.81 -7.665,10.413c-0.761,0.613 -1.899,2.147 -0.972,4.133c0.407,0.873 0.282,1.732 0.972,2.344c0.709,0.63 -3.684,-1.837 -4.248,-1.414c-1.211,0.911 -6.652,1.086 -8.008,1.474Z",
    style: {
      fill: "#37694c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.159,137.269c0.258,-1.901 14.403,16.32 30.072,33.059c8.805,9.406 18.274,18.259 25.585,23.019c2.461,1.603 4.215,2.967 6.1,3.694c2.535,0.977 -1.479,5.592 -4.182,4.973c-8.635,-1.978 -21.4,-14.758 -32.718,-28.464c-13.609,-16.479 -25.125,-34.296 -24.856,-36.281Z",
    style: {
      fill: "#1c4c35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.947,125.491c-4.227,1.576 -11.076,1.787 -14.671,1.107c-3.628,-0.687 -8.226,-6.894 -8.256,-10.265c-0.036,-4.044 1.617,-7.588 4.492,-9.081c3.584,-1.86 10.334,0.987 12.805,-0.326c2.302,-1.223 1.869,-5.584 2.021,-7.554c0.203,-2.616 4.206,-5.086 9.045,-4.802c1.649,0.097 5.471,0.823 7.483,2.631c1.912,1.719 2.668,5.099 2.672,7.025c0.008,3.642 -2.52,8.799 -5.119,12.343c-2.598,3.544 -6.208,7.332 -10.472,8.922Z",
    style: {
      fill: "#f6b92d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.167,
    cy: 49.269,
    r: 9.164,
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.749,
    cy: 80.647,
    r: 11.425,
    style: {
      fill: "#303030"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.771,34.535c1.768,4.098 8.791,6.083 9.803,12.26c0.792,4.836 0.111,11.45 -2.555,16.237c-2.909,5.223 -8.995,12.187 -14.898,15.099c-5.903,2.912 -14.771,4.251 -20.519,2.374c-5.748,-1.877 -12.288,-8.884 -13.97,-13.635c-1.674,-4.731 -0.924,-10.052 1.645,-13.977c3.445,-5.266 10.267,-6.843 12.245,-11.675c1.978,-4.832 -0.486,-12.652 -0.379,-17.319c0.185,-8 6.101,-13.123 12.273,-13.667c5.856,-0.515 13.623,1.787 15.549,11.978c0.542,2.871 -0.825,8.546 0.806,12.326Z",
    style: {
      fill: "#f4b69f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.258,65.211l0,90.637c0,10.719 -8.703,19.422 -19.422,19.422l-116.68,0c-10.719,0 -19.422,-8.703 -19.422,-19.422l0,-90.637c0,-10.719 8.703,-19.422 19.422,-19.422l116.68,0c10.719,0 19.422,8.703 19.422,19.422Z",
    style: {
      fill: "#2e5a41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.94,132.938l0,12.945c0,3.572 -2.9,6.472 -6.472,6.472l-13.898,0c-3.572,0 -6.472,-2.9 -6.472,-6.472l0,-12.945c0,-3.572 2.9,-6.472 6.472,-6.472l13.898,0c3.572,0 6.472,2.9 6.472,6.472Z",
    style: {
      fill: "#dfd8ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.725,132.938l0,12.945c0,3.572 -2.9,6.472 -6.472,6.472l-13.898,0c-3.572,0 -6.472,-2.9 -6.472,-6.472l0,-12.945c0,-3.572 2.9,-6.472 6.472,-6.472l13.898,0c3.572,0 6.472,2.9 6.472,6.472Z",
    style: {
      fill: "#dfd8ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.125,132.938l0,12.945c0,3.572 -2.9,6.472 -6.472,6.472l-13.898,0c-3.572,0 -6.472,-2.9 -6.472,-6.472l0,-12.945c0,-3.572 2.9,-6.472 6.472,-6.472l13.898,0c3.572,0 6.472,2.9 6.472,6.472Z",
    style: {
      fill: "#dfd8ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.925,90.008l0,12.945c0,3.572 -2.9,6.472 -6.472,6.472l-13.898,0c-3.572,0 -6.472,-2.9 -6.472,-6.472l0,-12.945c0,-3.572 2.9,-6.472 6.472,-6.472l13.898,0c3.572,0 6.472,2.9 6.472,6.472Z",
    style: {
      fill: "#dfd8ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,90.008l0,12.945c0,3.572 -2.9,6.472 -6.472,6.472l-13.898,0c-3.572,0 -6.472,-2.9 -6.472,-6.472l0,-12.945c0,-3.572 2.9,-6.472 6.472,-6.472l13.898,0c3.572,0 6.472,2.9 6.472,6.472Z",
    style: {
      fill: "#dfd8ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,90.008l0,12.945c0,3.572 -2.9,6.472 -6.472,6.472l-13.898,0c-3.572,0 -6.472,-2.9 -6.472,-6.472l0,-12.945c0,-3.572 2.9,-6.472 6.472,-6.472l13.898,0c3.572,0 6.472,2.9 6.472,6.472Z",
    style: {
      fill: "#dfd8ae"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.788,
    y: 35.396,
    width: 5.814,
    height: 24.688,
    style: {
      fill: "#1c4332"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.84,
    y: 35.396,
    width: 5.814,
    height: 24.688,
    style: {
      fill: "#1c4332"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.02,226.436c-7.408,-1.743 -17.991,-4.322 -19.601,-11.708c-2.142,-9.826 6.316,-21.411 22.147,-22.289c2.929,-0.162 9.621,-2.617 11.919,-4.38c6.93,-5.318 9.871,-21.775 16.207,-28.495c13.133,-13.927 42.067,-11.127 52.113,5.786c8.922,15.02 2.831,32.603 -3.402,40.561c-5.374,6.862 -15.85,12.611 -23.557,16.149c-7.043,3.232 -14.961,4.469 -22.686,5.074c-9.304,0.729 -24.35,1.37 -33.14,-0.698Z",
    style: {
      fill: "#275236"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualStarterscreen);
export default __webpack_public_path__ + "static/media/manual-starterscreen.5b01240857300c9e0a2d82143e636c56.svg";
export { ForwardRef as ReactComponent };